import { RESOURCES_CONSTANTS } from "config/constants";

export const INIT_FORM = {
    studentPenalizedId: 0,
    reasonForPenalizeId: 0,
    penalizeId: 0,
    blockId: 0,
    details: "",
    penalizeDays: ""
};
export const STYLE_PROPS_CUSTOM_SELECT = {
    minWidth: "180px",
    width: {
        container: "unset",
        containerSelect: "100%"
    }
};
const { BLOCK_IDS } = RESOURCES_CONSTANTS;
export const DETAILS_PLACEHOLDERS = {
    [BLOCK_IDS.TEMPORARY_BLOCK]: "Describe el motivo de la sanción",
    [BLOCK_IDS.UNBLOCK]: "Detalla el motivo por el cual el alumno será desbloqueado."
};